import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PageHero {
  id: number;
  pageKey: string;
  eyebrowText: string | null;
  title: string;
  accentText: string | null;
  subtitle: string | null;
  backgroundType: 'Image' | 'Video';
  mediaAssetId: number | null;
  fallbackMediaAssetId: number | null;
}

export interface UpdatePageHeroRequest {
  eyebrowText: string | null;
  title: string;
  accentText: string | null;
  subtitle: string | null;

  // Backend enum:
  // Image = 0
  // Video = 1
  backgroundType: number;

  mediaAssetId: number | null;
  fallbackMediaAssetId: number | null;
}

export interface MediaUploadResponse {
  id: number;
  fileName: string;
  contentType: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class PageHeroService {
  constructor(private readonly http: HttpClient) {}

  getHero(pageKey: string): Observable<PageHero> {
    return this.http.get<PageHero>(
      `${environment.apiUrl}/pageHeroes/${pageKey}`
    );
  }

  updateHero(
    pageKey: string,
    request: UpdatePageHeroRequest
  ): Observable<PageHero> {
    return this.http.put<PageHero>(
      `${environment.apiUrl}/pageHeroes/${pageKey}`,
      request,
      { withCredentials: true }
    );
  }

  uploadMedia(file: File): Observable<MediaUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<MediaUploadResponse>(
      `${environment.apiUrl}/media`,
      formData,
      { withCredentials: true }
    );
  }

  getHomeDefaults(): Observable<HomeHeroDefaults> {
    return this.http.get<HomeHeroDefaults>(
        `${environment.apiUrl}/pageHeroes/home/defaults`,
        { withCredentials: true }
    );
    }
  getMediaUrl(mediaAssetId: number | null): string | null {
    return mediaAssetId
      ? `${environment.apiUrl}/media/${mediaAssetId}`
      : null;
  }
}

export interface HomeHeroDefaults {
  mediaAssetId: number;
  fallbackMediaAssetId: number;
}